import axios from 'axios';  
import { BASEURL } from '../datatypes/deployment';


export function requestMainData(userLevel: string) {
    // const urlStart = "http://localhost:5000/r3qu3$+";
    // const urlStart = "https://mcm-api.askslim.org/r3qu3$+";
    const urlStart = BASEURL + "/r3qu3$+";
    return axios ({
        method: 'get', 
        url: urlStart + "?level=" + userLevel        
    }).then((response) => {
        const data = response.data;
        if (response.status === 200) {
            return {
                data: data
            }
        }
    }).catch((error) => {
        return {
            data: {error: error}
        }
    })
}

